import { render, staticRenderFns } from "./ShopeeAuthorize.vue?vue&type=template&id=45a55162&scoped=true&"
import script from "./ShopeeAuthorize.vue?vue&type=script&lang=js&"
export * from "./ShopeeAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./ShopeeAuthorize.vue?vue&type=style&index=0&id=45a55162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a55162",
  null
  
)

export default component.exports